import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/vanilla/shallow";

export type ZustandAppState = Record<string, unknown>;

export const useAppState = createWithEqualityFn<ZustandAppState>(
  () => ({}),
  shallow
);
